import { useQuery } from '@tanstack/react-query'
import { OrganizationAPI } from '../../apis'

type propsType = {
  orgId: number | null
}

const useOrganization = (props: propsType) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['organization', 'get', props.orgId],
    queryFn: () => OrganizationAPI.getOrganization(props.orgId),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    retry: 1,
  })

  return { data, isLoading, isError, error }
}

export default useOrganization
